import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Collapsible, Markdown, Text } from "@wojo/ui";
import { useId } from "react";
import { useTourPageContext } from "../../_client/context";
import { TourSectionId } from "../../_client/hooks";
import styles from "./Faq.module.scss";
import { SchemaScript } from "@wojo/storyblok/src/components/schema-script";

export const Faq = () => {
    const { tourContent } = useTourPageContext();
    const headingId = useId();
    const { productPage } = useI18n("productPage");
    const faqHeading = productPage.faq.heading.l();
    const faqs = tourContent.faq?.items;

    if (!faqs || faqs.length === 0) {
        return null;
    }

    const faqData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        name: "FAQ",
        mainEntity: faqs.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
            },
        })),
    };

    return (
        <section
            id={TourSectionId.FAQ}
            tabIndex={-1}
            aria-labelledby={headingId}
            className={styles.container}
        >
            <Text.Heading
                order="3"
                tag="h2"
                id={headingId}
                style={{ paddingBottom: "var(--g-spacing-lg)" }}
            >
                {faqHeading}
            </Text.Heading>
            <SchemaScript data={faqData} />
            {faqs.map((faq) => {
                return (
                    <Collapsible
                        key={faq.question}
                        title={faq.question}
                        onToggle={(isExpanded) => {
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_action: isExpanded
                                        ? "EXPANDED"
                                        : "COLLAPSED",
                                    ga4_object: "FAQ",
                                    eventCategory: "collapsible-faq",
                                    eventAction: isExpanded ? "open" : "closed",
                                    faqText: faq.question || "",
                                    faqState: isExpanded
                                        ? "expanded"
                                        : "collapsed",
                                },
                            });
                        }}
                    >
                        <Markdown markdown={faq.answer ?? ""} />
                    </Collapsible>
                );
            })}
        </section>
    );
};
